import { render, staticRenderFns } from "./confirmacao-solicitacoes.vue?vue&type=template&id=d11297d6&"
import script from "./confirmacao-solicitacoes.vue?vue&type=script&lang=js&"
export * from "./confirmacao-solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./confirmacao-solicitacoes.vue?vue&type=style&index=0&id=d11297d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports